// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f335c21","455":"eb1e0294","977":"d17f2177"}[chunkId] + ".chunk.js";
};